import React from 'react';
import App from './components/App';
import {BrowserRouter as Router} from "react-router-dom";
import AuthService from "./services/auth-service";
import HttpService from "./services/http-service";
import "./services/i18n";
import {createRoot} from "react-dom/client";

const renderApp = () => {
    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(
        // https://github.com/remix-run/history/issues/435#issuecomment-287853906:
        <Router basename={`${window.location.pathname}#`}>
            <App/>
        </Router>,
        container);
};

HttpService.configure();
AuthService.initKeycloak(renderApp);
